export const industryNewsRecords = [
  {
    slug: "industry-new-power-system-bluebook-energy-saving-transformers",
    category: "industry",
    title: "《新型电力系统发展蓝皮书》发布，配网节能变压器迎来政策红利",
    excerpt: "国家能源局发布的《新型电力系统发展蓝皮书》明确提出，要加快配电网智能化改造，全面推广一级能效配电变压器。",
    date: "2026-01-15",
    views: 168,
    sourceName: "行业政策整理",
    sourceUrl: "",
    content: [
      "国家能源局发布的《新型电力系统发展蓝皮书》明确提出，要加快配电网智能化改造，全面推广一级能效配电变压器。",
      "根据规划，到2030年，我国新型电力系统建设将带动中低压节能变压器市场规模突破2000亿元，低损耗、高可靠性产品将成为市场主流。江苏宏邦紧跟政策导向，持续推进S20、SCB14等系列节能变压器的规模化生产，助力电网节能降碳。"
    ]
  },
  {
    slug: "industry-grid-distribution-equipment-technical-standard-quality-upgrade",
    category: "industry",
    title: "国家电网发布《配网设备技术标准》，推动变压器行业质量升级",
    excerpt: "新版《10kV配电变压器技术标准》对产品能效、噪声、抗短路能力提出更高要求，推动行业向高质量方向升级。",
    date: "2025-09-20",
    views: 152,
    sourceName: "行业标准整理",
    sourceUrl: "",
    content: [
      "国家电网有限公司发布新版《10kV配电变压器技术标准》，对产品的能效、噪声、抗短路能力提出了更高要求。",
      "新标准明确，新建配电工程优先采用一级能效变压器，并对出厂试验、型式试验提出了更严格的检测要求。行业分析指出，这将加速行业内落后产能的淘汰，推动优势企业向高质量、高技术方向转型。"
    ]
  },
  {
    slug: "industry-power-equipment-growth-plan-2025-2026",
    category: "industry",
    title: "三部门印发《电力装备行业稳增长工作方案（2025-2026年）》",
    excerpt: "工信部、市场监管总局、国家能源局联合印发方案，提出推动传统电力装备稳定增长，支持新能源和智能电网装备创新项目。",
    date: "2025-09-12",
    views: 141,
    sourceName: "中国政府网",
    sourceUrl: "https://www.gov.cn/lianbo/bumen/202509/content_7040865.htm",
    content: [
      "工业和信息化部、市场监管总局、国家能源局联合印发《电力装备行业稳增长工作方案（2025-2026年）》，提出2025至2026年传统电力装备年均营收增速保持6%左右，新能源装备营收稳中有升。",
      "方案强调支持新能源、智能电网装备等领域创新项目，并通过强化标准支撑、推动数字化绿色化转型、扩大国内有效需求和开拓国际市场，夯实电力装备行业增长基础。对于变压器、成套开关设备和箱式变电站企业而言，标准升级和工程需求释放将共同推动产品结构升级。"
    ]
  },
  {
    slug: "industry-customs-transformer-export-2024-growth",
    category: "industry",
    title: "海关总署数据：2024年我国变压器出口额同比增长12.3%，新兴市场表现突出",
    excerpt: "东南亚、中东、非洲等地区出口增速均超过20%，耐候性和定制化产品需求明显提升。",
    date: "2025-04-10",
    views: 136,
    sourceName: "海关数据整理",
    sourceUrl: "",
    content: [
      "据海关总署统计数据，2024年我国电力变压器出口额达187.6亿元，同比增长12.3%。",
      "其中，东南亚、中东、非洲等地区出口增速均超过20%，成为拉动出口增长的主要动力。市场对耐候性、定制化产品的需求显著提升，为具备快速响应与本地化服务能力的企业带来新机遇。"
    ]
  },
  {
    slug: "industry-transformer-efficiency-standard-gb-20052-2020",
    category: "industry",
    title: "《变压器能效限定值及能效等级》（GB 20052-2020）全面实施，能效门槛大幅提高",
    excerpt: "新标准将配电变压器能效分为三级，新采购配电变压器需达到更高能效要求，高损耗产品将逐步退出市场。",
    date: "2024-11-05",
    views: 128,
    sourceName: "国家标准整理",
    sourceUrl: "",
    content: [
      "国家强制性标准《电力变压器能效限定值及能效等级》（GB 20052-2020）已全面实施，新标准将配电变压器能效分为三级，其中一级能效指标较旧标准提升约10%。",
      "自2025年起，新采购配电变压器必须达到二级及以上能效要求，高损耗产品将逐步退出市场。江苏宏邦全系列产品均已按新标准进行能效升级，多款产品达到一级能效水平。"
    ]
  },
  {
    slug: "industry-power-equipment-high-quality-development-action-plan",
    category: "industry",
    title: "工信部发布《电力装备高质量发展行动计划》，推动行业向智能化、绿色化转型",
    excerpt: "行动计划提出重点发展节能高效变压器、智能配电设备等产品，支持企业开展智能制造改造。",
    date: "2024-06-18",
    views: 119,
    sourceName: "工信部政策整理",
    sourceUrl: "",
    content: [
      "工业和信息化部发布《电力装备高质量发展行动计划（2024-2026年）》，提出重点发展节能高效变压器、智能配电设备等产品，支持企业开展智能制造改造，提升产品数字化管控能力。",
      "计划明确，到2026年，骨干企业数字化车间普及率达到60%以上，这为变压器行业的技术升级指明了方向。对于配电设备制造企业而言，数字化制造、检测能力和绿色产品体系将成为长期竞争重点。"
    ]
  },
  {
    slug: "industry-offshore-wind-transformer-launch-special-equipment-demand",
    category: "industry",
    title: "66kV海上风电变压器持续突破，新能源专用变压器需求加速释放",
    excerpt: "海上风电项目持续推进，面向高盐雾、高湿度、高可靠性场景的专用变压器产品成为新能源装备重要增长方向。",
    date: "2024-03-26",
    views: 112,
    sourceName: "国际风力发电网",
    sourceUrl: "https://wind.in-en.com/html/wind-2455704.shtml",
    content: [
      "公开报道显示，国内企业持续推进大容量油浸式海上风电变压器研发和应用，海上风电场景对高可靠性、耐候性和专用化设计提出了更高要求。",
      "随着海上风电项目持续推进，面向高盐雾、高湿度、高可靠性要求场景的专用变压器产品将成为新能源装备中的重要增长方向。对于变压器企业而言，新能源配套设备的迭代速度和专业场景扩张也意味着更广阔的产品应用空间。"
    ]
  },
  {
    slug: "industry-energy-efficiency-improvement-key-products-transformer-retrofit",
    category: "industry",
    title: "国家发改委发布《重点用能产品能效提升行动方案》，变压器节能改造纳入重点工程",
    excerpt: "方案明确将配电变压器列为重点节能改造对象，推动存量高损耗设备加快更新。",
    date: "2023-11-22",
    views: 108,
    sourceName: "政策方案整理",
    sourceUrl: "",
    content: [
      "国家发改委发布《重点用能产品能效提升行动方案》，明确将配电变压器列为重点节能改造对象，提出到2025年，完成存量高损耗配电变压器改造200万台以上，全面淘汰S11及以下能效等级产品。",
      "方案要求新建工业与配电项目优先选用一级能效变压器，预计带动节能变压器市场规模超500亿元，为行业绿色转型提供了明确政策指引。"
    ]
  },
  {
    slug: "industry-grid-investment-distribution-network-2023",
    category: "industry",
    title: "两大电网扩大配网投资，2023年配网建设规模超5000亿元",
    excerpt: "农村电网升级、工业园区配电改造与新能源并网配套工程推动配网变压器和箱式变电站需求增长。",
    date: "2023-05-16",
    views: 102,
    sourceName: "电网投资信息整理",
    sourceUrl: "",
    content: [
      "据国家电网、南方电网公开信息，2023年两大电网企业配网建设投资规模合计突破5000亿元，重点投向农村电网升级、工业园区配电改造与新能源并网配套工程。",
      "配网变压器、箱式变电站等设备需求持续增长，其中10kV-35kV节能型变压器采购占比同比提升18%，为变压器制造企业带来稳定市场增量。"
    ]
  },
  {
    slug: "industry-global-transformer-shortage-ai-grid-upgrade",
    category: "industry",
    title: "AI算力与电网升级推高全球变压器需求，高可靠供电设备进入紧平衡周期",
    excerpt: "全球电网升级、能源转型与AI数据中心扩张叠加，正在推动大型电力变压器进入供需紧张周期。",
    date: "2026-03-18",
    views: 96,
    sourceName: "国际能源网",
    sourceUrl: "https://www.in-en.com/article/html/energy-2342209.shtml",
    content: [
      "公开行业资讯显示，全球变压器市场正在经历结构性供需变化，北美、欧洲和新兴市场对高等级变压器的需求快速上升，交货周期和价格都出现明显拉长与抬升。",
      "能源转型、电网老化改造和AI数据中心扩容，共同推高了对高可靠供电设备的需求，也让变压器制造企业的交付能力、标准能力和海外适配能力成为竞争核心。"
    ]
  }
];
